// src/components/product/ProductStateDropdown.js
import React from "react";
import { PRODUCT_STATES } from "../../utils/expirationPredictor";

export function ProductStateDropdown({ 
  productStateOptions, 
  value, 
  onChange, 
  disabled = false,
  category = "",
  labels = {}
}) {
  // Ensure we always have at least FRESH as an option
  const options = productStateOptions?.length > 0 
    ? productStateOptions 
    : [PRODUCT_STATES.FRESH];

  // Safe charAt function
  const formatState = (state) => {
    if (!state || typeof state !== 'string') return "Fresh";
    return labels?.productStateMap?.[state] || (state.charAt(0).toUpperCase() + state.slice(1));
  };

  return (
    <div>
      <select
        name="productState"
        value={value}
        onChange={onChange}
        disabled={disabled}
        required
        className="w-full px-3 py-2.5 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-neutral-900 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-600 dark:focus:ring-green-500"
      >
        {options.map((state) => (
          <option key={state} value={state}>
            {formatState(state)}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
        {(labels.availableFor || "Available for")} {category || labels.selectedCategory || "selected category"}
      </p>
    </div>
  );
}